class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") && this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);

      if (!sectionElement) return;

      // Pour cart-count-header, on remplace l'élément entier pour que les classes soient correctement mises à jour
      if (section.id === "cart-count-header") {
        const newElement = this.getSectionDOM(parsedState.sections[section.id], section.selector);
        if (newElement && sectionElement.parentNode) {
          sectionElement.parentNode.replaceChild(newElement, sectionElement);
        }
      } else {
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  getSectionDOM(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: "main-cart-items",
        selector: ".main-cart-items",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".cart-icon-bubble",
      },
      {
        id: "footer-cart-drawer",
        section: "footer-cart-drawer",
        selector: ".footer-cart-drawer",
      },
      {
        id: "main-cart-items-page",
        section: "main-cart-items-page",
        selector: ".main-cart-items-page",
      },
      {
        id: "cart-count-header",
        section: "cart-count-header",
        selector: "#cart-count-header",
      },
    ];
  }

  addAttributes(attributes) {
    console.log("addAttributes", attributes);
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: "main-cart-items",
        selector: ".main-cart-items",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".cart-icon-bubble",
      },
      {
        id: "footer-cart-drawer",
        section: "footer-cart-drawer",
        selector: ".footer-cart-drawer",
      },
      {
        id: "main-cart-items-page",
        section: "main-cart-items-page",
        selector: ".main-cart-items-page",
      },
      {
        id: "cart-count-header",
        section: "cart-count-header",
        selector: "#cart-count-header",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
